import { useMemo } from 'react';

import Tippy from '@tippyjs/react';

import { iaRa } from 'lib/helpers/utility';

import Select from 'components/shared/Select/Select';

const compactStyles = {
  valueContainer: { padding: '0 4px', gap: 2 },
  multiValue: { margin: 1, minHeight: 20 },
  multiValueLabel: { padding: '0 2px 0 4px', fontSize: 11, lineHeight: '16px' },
  multiValueRemove: { padding: '0 2px' }
};

const StatesCellSelect = ({
  data,
  stateOptions,
  oppositeStateMap,
  onStatesChange,
  isInNetwork
}) => {
  const provider = data;
  const providerId = provider?.value ?? provider?.id;
  const selectedIds = iaRa(provider?.state_ids);

  const blockedIds = useMemo(
    () => new Set(iaRa(oppositeStateMap?.get?.(providerId))),
    [oppositeStateMap, providerId]
  );

  const oppositeLabel = isInNetwork ? 'out-of-network' : 'in-network';

  const options = useMemo(
    () => stateOptions.map((opt) => ({ ...opt, isDisabled: blockedIds.has(opt.value) })),
    [stateOptions, blockedIds]
  );

  const value = useMemo(
    () => options.filter((opt) => selectedIds.includes(opt.value)),
    [options, selectedIds]
  );

  const formatOptionLabel = (opt, { context }) => {
    if (context !== 'menu' || !opt.isDisabled) return opt.label;

    return (
      <Tippy
        content={`This state is already used for ${oppositeLabel} for this provider.`}
        className="tippy-dark"
        arrow
        appendTo={() => document.body}>
        <span className="block w-full">{opt.label}</span>
      </Tippy>
    );
  };

  const handleChange = (selected) => {
    onStatesChange?.(
      providerId,
      iaRa(selected).map((opt) => opt.value)
    );
  };

  return (
    <Select
      isMulti
      isClearable={false}
      placeholder="Select states"
      options={options}
      value={value}
      onChange={handleChange}
      formatOptionLabel={formatOptionLabel}
      menuPortalTarget={document.body}
      styles={compactStyles}
      onClick={(e) => e.stopPropagation()}
      classNames={{
        option: ({ isDisabled }) =>
          isDisabled ? '!cursor-not-allowed !text-neutral-400' : '!cursor-pointer'
      }}
    />
  );
};

export default StatesCellSelect;
